import React from "react";
import ChatDivide from "../assets/img/menu_bar_bottom_line.png";
import {useHistory} from "react-router-dom";
import UnderLineImage from '../assets/img/subject_underline_shine_effect.png'


const data = [
    {
        category: "Site Access",
        qa: [
            {
                q: 'Will I be able to access this site again after I log out? ',
                a: 'Please click on the ‘Access Event’ link in your reminder email to access this site again.'
            },
            {
                q: 'Will I be able to log in using multiple devices? ',
                a: 'Only one device per attendee can access this site at any one time.'
            }
        ]
    },
    {
        category: "Site Navigation",
        qa: [
            {
                q: 'How do I navigate around the site? ',
                a: 'Please click on the hotspots in the home page to access the various pages on this site. Alternatively, you can click on the respective tabs on the top menu bar too.'
            },
        ]
    },
    {
        category: 'Connection',
        qa: [
            {
                q: 'What is the minimum specification for best user experience?',
                a: 'For best user experience, we recommend using Google Chrome internet browser from your computer. If you don’t already have Google Chrome, you can download it <a style=" color: #e0cd9a;" href="https://www.google.com/intl/en_sg/chrome/" target="_blank">here </a> for free.\n' +
                    ' \n' +
                    'Do a quick check that your system is compatible with the virtual environment by clicking <a  style=" color: #e0cd9a;" href="https://cff.6connex.com/event/CF/system-check" target="_blank">here</a>.\n' +
                    ' \n' +
                    'If you are a mobile user, please view the website in landscape for the best experience. \n' +
                    '\n' +
                    'If you are using a company-issued device, please ensure that there are no security firewalls restricting access to external webpages. If your company-issued device has restricted access, please join this event via your personal device.\n' +
                    '\n' +
                    'We suggest mirroring the content to a TV screen, to enhance your digital experience.\n'
            }
        ]
    },
    {
        category: 'Live Stream',
        qa: [
            {
                q: 'My video is jerky. What should I do? ',
                a: 'For a smoother live stream, we recommend the following: \n' +
                    '•&nbsp;Please make sure that your internet connection is stable with sufficient bandwidth\n' +
                    '•&nbsp;Cancel or pause concurrent applications or websites that are using up your bandwidth\n' +
                    '•&nbsp;Refresh the page to reload the video\n'
            },

            {
                q: 'I am unable to hear any sound from this site. What should I do?',
                a: 'Please ensure that your device\'s audio and browser tab is not muted. You may check for audio sync to verify if it’s working <a style=" color: #e0cd9a;" href="https://cff.6connex.com/event/CF/system-check" target="_blank">here</a>.'
            },
        ]
    },

    {
        category: 'Others',
        qa: [
            {
                q: 'I have some questions about the event. Is there someone I can speak to? ',
                a: 'For technical enquiries, please email us at help@singaporebusinessawards.com, or call us at our technical hotline 1800-222-8868 (Singapore only) or +65-6694-8700 (overseas).\n' +
                    '\n' +
                    'For general enquiries post-event, please contact anglcc@sph.com.sg or claire.ho@dhl.com.\n'
            }
        ]
    }


    ];

class AccordionItem extends React.Component {
    state = {
        opened: false
    }

    render() {
        const {
            props: {
                category,
                qa
            },
            state: {
                opened
            }
        } = this

        return (
            <div
                {...{
                    className: `accordion-item, ${opened && 'accordion-item--opened'}`,
                    onClick: () => {
                        this.setState({opened: !opened})
                    }
                }}
            >
                <div className='accordion-item__line'>
                    <div className='accordion-item__title'>
              <span className='accordion-item__ques'>
              {category}
            </span>
                    </div>
                    {opened ? <span className='icon_up'/> : <span className='icon_down'/>}
                </div >
                {opened && (<div >
                        {
                            qa.map(item =>
                                <div className='accordion-item_resp_line'>
                                    <table className='qa-table'>
                                        <tr>
                                            <td className='qa-table-td'>Q:</td>
                                            <td className='accordion-item_question'>{item.q}</td>

                                        </tr>
                                        <tr>
                                            <td>A:</td>
                                            <td className='accordion-item_answer'  dangerouslySetInnerHTML={{__html: item.a}} ></td>
                                        </tr>
                                    </table>
                                </div>
                            )
                        }
                    </div>
                )}
            </div>
        )
    }
}

const FAQPage = () => {
    const history = useHistory();
    const [height, setHeight] = React.useState(window.innerHeight * 0.5);
    React.useEffect(() => {
        function handleResize() {
            if (window.innerHeight > 700) {
                setHeight(window.innerHeight * 0.5)
            } else {
                setHeight(window.innerHeight * 0.3)
            }
        }

        window.addEventListener('resize', handleResize)
    })

    const onReset = () => history.goBack();

    return (

        <div className={'faq-container'}>
            <div className={'close-button-qa'} onClick={onReset}>X</div>
            <div style={{ display: 'flex', justifyContent: 'center', fontSize: '1.8vw', fontFamily: 'DINPro-Bold', height: '3.2vw'}}>
                <span style={{padding: '10px 20px',}}>Frequently Asked Questions</span>
            </div>
            <img src={ChatDivide} alt="ChatHeader" style={{width: '100%', height: 10}}/>
            <div className="faq-section">
                <div style={{height: height}} className="faq-wrapper scroll custom-scrollbar">
                    <ul className="accordion-list-qa">
                        {data.map((item, key) => {
                            return (
                                <li {...{className: 'accordion-list__item', key}}>
                                    <AccordionItem {...item} />
                                    <div className='line-container'>
                                        <img src={UnderLineImage} style={{width: '120%', height: 4}}/>
                                    </div>
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default FAQPage;
